import React from 'react';
import { connect } from 'react-redux';

import store from '../store';

import {
    feedsSetFieldMap,
} from '../modules/Feeds/actions';

const { dispatch } = store;

class FormFieldList extends React.Component {
    render() {
        const { fields, sobjectName, idx, selected } = this.props;

        if (fields === null) {
            return (
                <p>Please make sure your form has some fields!</p>
            );
        }

        return (
            <select className="value gaddon-setting gaddon-select" value={selected} onChange={e => {
                dispatch(feedsSetFieldMap({ gf: e.target.value, sobjectName, idx, }));
            }}>
                {
                    fields.map((field, idx) => {
                        return <option key={`${field.value}_${idx}`} value={field.value}>{`${field.label}`}</option>;
                    })
                }
            </select>
        );
    }
}

const mapStateToProps = function (store) {
    return {
        sobjectName: store.metaState.get('sobject').get('name'),
        fields: store.metaState.get('form').get('fields').toJS()
    };
};

export default connect(mapStateToProps)(FormFieldList);
